import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {connect} from 'react-redux';
import _get from "lodash/get";
import _isEmpty from 'lodash/isEmpty';
import _findIndex from "lodash/findIndex";
import _has from 'lodash/has';
import _forEach from "lodash/forEach";
import _isUndefined from 'lodash/isUndefined';
import {setTransactionAlertPreference} from '../../actions/transactionActions';
import EditTransactionPrefsForm from './EditTransactionPrefsForm';
import utils from '../../helpers/utils';
import {getLangCode, stringBundle} from '../../stringBundle';

class TransactionPrefs extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  componentDidMount() {
    window.parent.postMessage({type: "RESIZED", payload: document.body.scrollHeight}, window.REACT_APP_PARENT_HOST);
  }

  componentDidUpdate() {
    window.parent.postMessage({type: "RESIZED", payload: document.body.scrollHeight}, window.REACT_APP_PARENT_HOST);
  }

  shouldComponentUpdate(nextProps) {
    if (!(_has(nextProps.propAlertPref)) &&
      (_has(this.props.propAlertPref))) {
      return false;
    }
    return true;
  }

  handleSubmit(values) {
    let accountId = _get(this.props, 'propMember.accountId');

    let prefData = {
      preferences: {
        transaction: _get(values, 'transaction'),
        transfer: _get(values, 'transfer'),
        withdrawal: _get(values, 'withdrawal')
      }
    }
    const prev = this.props.propAlertPref;
    const pIndex = _findIndex(prev, { type: 'PURCHASE' });
    const tIndex = _findIndex(prev, { type: 'TRANSFER' });
    const wIndex = _findIndex(prev, { type: 'WITHDRAWAL' });
    const valuesBeforeChanged = {
      transaction: _get(prev[pIndex], 'value', ''),
      transfer: _get(prev[tIndex], 'value', ''),
      withdrawal: _get(prev[wIndex], 'value', '')
    }
    this.props.dispatch(setTransactionAlertPreference(prefData, null, accountId));
    _forEach(valuesBeforeChanged, (value, key) => {
      if (value !== prefData.preferences[key]) {
        utils.trackEventForManageAccount(key, this.localizedStringBundle.MANAGE_ACCOUNT_SAVE, true);
      }
    });
  }

  render() {
    const prefStatus = this.props.propAlertPrefStatus;
    if (!_isEmpty(this.props.propAlertPref)) {
      return (
        <div>
          <EditTransactionPrefsForm propAlertPref={this.props.propAlertPref} onSubmit={this.handleSubmit} />
        </div>
      );
    }
    if (!(_isUndefined(prefStatus)) && prefStatus !== 'success') {
      return (
        <div className="flex justify-center">
          <div className="loader self-center"></div>
        </div>
      )
    }
    return (
      <div/>
    )
  }

}

TransactionPrefs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  propAlertPref: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  propAlertPrefStatus: PropTypes.string
};

function mapStateToProps(state) {
  const { form, transactions } = state;
  if (form) {
    return { form: form.edittransactionpref, propAlertPrefStatus: transactions.alertPreferencesRequestStatus };
  }
  return { form: null, propAlertPrefStatus: null}
}

export default connect(mapStateToProps)(TransactionPrefs);



// WEBPACK FOOTER //
// ./src/containers/monitoring/TransactionPrefs.js